
import { Component    } from '@angular/core';
import { HostListener } from '@angular/core';

import { ConsoleService    } from '@service/console.service';
import { PlatformService   } from '@service/platform.service';
import { FilesystemService } from '@service/filesystem.service';

@Component({
    selector: 'section-banner',
    styleUrls: [ 'section-banner.template.scss' ],
    templateUrl: 'section-banner.template.html'
})
export class SectionBannerComponent {

    public banneri: number = 1;
    public content: any = [];

    public offsetx: number = -50;
    public offsety: number = -50;
    public offsetscroll: number = 0;
    public animate: boolean = false;

    constructor (private console: ConsoleService,
                 private platform: PlatformService,
                 private filesystem: FilesystemService) {

    }

    get desktop () {
        return (window.innerWidth > 992) ? true : false;
    }

    ngOnInit () {
        this.console.info('Starting SectionBanner');

        let main: any = this.filesystem.readSession('main');
        if (main) {
            this.content = main;
        }

        setTimeout(() => {
            this.animate = true;
        }, 600);

        setInterval(() => {
            this.banneri++;
            this.banneri = this.banneri > 3 ? 1 : this.banneri;
        }, 8000);
    }

    ngOnDestroy () {
        this.console.info('Destroying SectionBanner');
    }

    get language () {
        return this.filesystem.readSession('language');
    }

    get textForAnimation () {
        return this.platform.encapsulate(
            this.content[this.language].banner.text
        );
    }

    get titleForAnimation () {
        return this.platform.encapsulate(
            this.content[this.language].banner.title
        );
    }

    /*@HostListener('window:mousemove', [ '$event' ])
    public parallaxByMouse ($event: any) {
        let clientx: number = $event.clientX / window.innerWidth - 0.5;
        let clienty: number = $event.clientY / window.innerHeight - 0.5;

        this.offsetx = -50 - clientx / 0.5 * 2;
        this.offsety = -50 - clienty / 0.5 * 2;
    }

    @HostListener('window:deviceorientation', [ '$event' ])
    public parallaxByDevice ($event: any) {
        let clientx: number = $event.gamma / 40;
            clientx = clientx > 1 ? 1 : clientx;
            clientx = clientx < -1 ? -1 : clientx;
            
        let clienty: number = ($event.beta + 60) / 100;
            clienty = clienty > 1 ? 1 : clienty;
            clienty = clienty < -1 ? -1 : clienty;

        this.offsetx = -50 + clientx * 2;
        this.offsety = -50 + clienty * 2;
    }*/

    @HostListener('window:scroll', [ '$event' ])
    @HostListener('window:resize', [ '$event' ])
    public parallaxByScroll ($event: any) {
        this.offsetscroll = -window.scrollY / 3;
    }
}
